import { Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthenticationService } from '../_services';
import { Router, NavigationStart } from '@angular/router';
import { User, Role } from '../_models';

@Component({
  selector: 'app-mynav',
  templateUrl: './mynav.component.html',
  styleUrls: ['./mynav.component.scss']
})
export class MynavComponent implements OnInit {

  currentUser: User;

  @ViewChild('snav', { static: false }) usuarioMenu: MatSidenav;

  constructor(public breakpointObserver: BreakpointObserver,
    private router: Router,
    private authenticationService: AuthenticationService) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
  }

  closeAllSidenav() {
    this.usuarioMenu.close();
  }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  searchD = true;
  ontoggle() {
    this.searchD = !this.searchD;
  }

  get isAdmin() {
    // console.log(this.currentUser)
    return (this.currentUser && this.currentUser.admin.role === Role.Admin);
  }


  logout() {
    this.authenticationService.logout();
    this.router.navigate(['admin-auth']);
  }
}
